import { FieldValidationError } from '../../../types/form/field-validation-error';
export const requiredValidationRule = data => {
    if (!isDataValid(data))
        return FieldValidationError.Required;
};
const isDataValid = (data) => {
    if (data === null || data === undefined || data === false)
        return false;
    if (typeof data === 'string' && data.trim().length === 0)
        return false;
    if (Array.isArray(data) && data.length === 0)
        return false;
    return true;
};
//# sourceMappingURL=required-validation-rule.js.map